<h2 mat-dialog-title class="titulo_dialog" translate>dialog.contacto.title</h2>
<mat-divider class="dialog__divider--top"></mat-divider>
<mat-dialog-content>
  <h3 [innerHTML]="'dialog.contacto.olvidado' | translate"></h3>
  <p [innerHTML]="'dialog.contacto.contacto' | translate"></p>
  <div class="contact__mediatext" fxFill fxLayout="row" fxLayoutAlign="start center">
    <mat-icon class="icon-ic_telephone" color="accent"></mat-icon>
    <div fxLayout="column" fxLayoutAlign="space-between start">
      <p class="telefono-email-titulo" [innerHTML]="'Telefono' | translate"></p>
      <h5 class="telefono-email-datos">{{ telefono }}</h5>
    </div>
  </div>

  <p [innerHTML]="'dialog.contacto.horario' | translate"></p>
  <div class="contact__mediatext" fxFill fxLayout="row" fxLayoutAlign="space-around center">
    <mat-icon class="icon-ic_inbox_message" color="accent"></mat-icon>
    <div fxFlex fxLayout="column" fxLayoutAlign="space-between start">
      <p class="telefono-email-titulo" translate>dialog.contacto.email</p>
      <h5 class="telefono-email-datos">{{ email }}</h5>
    </div>
  </div>
  <p [innerHTML]="'dialog.contacto.cierre' | translate"></p>
</mat-dialog-content>
<mat-divider class="dialog__divider--bottom"></mat-divider>
<mat-dialog-actions align="end">
  <button
    id="contactoButtonCloseDialog"
    mat-flat-button
    mat-dialog-close
    color="accent"
    cdkFocusInitial
    [innerHTML]="'Cerrar' | translate"
  ></button>
</mat-dialog-actions>
